<template>
  <div class="">
    <span v-if="!getUrl" :class="$attrs.class" class="block font-bold">
      <slot></slot>
    </span>
    <a v-else :href="getUrl" :class="$attrs.class" data-spinner="table" class="cursor-pointer ajax block font-bold">
      <slot></slot>

      <span class="ml-2"></span>

      <aw-icon
        v-if="sort && getSortIcon"
        :icon="getSortIcon"
        class="mr-2 w-4 h-4  text-bc-blue "
      ></aw-icon>
    </a>
  </div>
</template>

<script>
//import $ from 'cash-dom'

export default {
  inheritAttrs: false,
  props: ['header', 'sort', 'filter', 'controlName', 'colName', 'modelValue'],
  emits: ['update:modelValue'],
  data() {
    return {
      sortState: 0
    }
  },
  computed: {
    getSortIcon() {
      if (this.sort.dir == 'desc') return 'sort-down'
      if (this.sort.dir == 'asc') return 'sort-up'

      return null
    },
    getUrl() {
      // 1 klik -  neni nastaveny sort, prvni klik tak na ASC
      if (!this.sort) return this.header?.sort

      // 2 klik - je to ASC, tak to na DESC
      if (this.sort && this.sort.dir == 'asc')
        return this.header.sort.replace('=ASC', '=DESC')

      // 3 klik je to DESC tak to smazu
      if (this.sort && this.sort.dir == 'desc')
        return this.header.sort.replace('=DESC', '').replace('=ASC', '')

      return null
    }
  },
}
</script>
